import { FieldValues } from 'react-hook-form'
import formatNumberToString, {
  formatNumberToINRCommaSeparatedString,
} from '../common/numbers/format-number-to-string'
import { atalPensionYojanaTable } from './apy-table'

/* eslint-disable @typescript-eslint/no-unused-vars */
export function sipFormulaEstReturns(
  amount: string,
  err: string,
  timeperiod: string,
) {
  const i = parseFloat(err) / 100 / 12
  const returns = (
    parseInt(amount, 10) *
    ((1 + i) ** (parseInt(timeperiod, 10) * 12) - 1) *
    ((1 + i) / i)
  ).toFixed(0)
  return Math.round(
    parseFloat(returns) - parseInt(amount, 10) * parseInt(timeperiod, 10) * 12,
  ).toLocaleString('en-IN')
}

export function sipFormulaTotalValue(
  amount: string,
  err: string,
  timeperiod: string,
) {
  const i = parseFloat(err) / 100 / 12
  return Math.round(
    parseInt(amount, 10) *
      ((1 + i) ** (parseInt(timeperiod, 10) * 12) - 1) *
      ((1 + i) / i),
  ).toLocaleString('en-IN')
}

export function sipFormulaFreqEstReturns(
  amount: string,
  err: string,
  timeperiod: string,
) {
  const i = parseFloat(err) / 100 / 12
  const returns = (
    parseInt(amount, 10) *
    ((1 + i) ** (parseInt(timeperiod, 10) * 12) - 1) *
    ((1 + i) / i)
  ).toFixed(0)
  return Math.round(
    parseFloat(returns) - parseInt(amount, 10) * parseInt(timeperiod, 10) * 12,
  )
}

export function sipFormulaFreqTotalValue(
  amount: string,
  err: string,
  timeperiod: string,
) {
  const i = parseFloat(err) / 100 / 12
  return Math.round(
    parseInt(amount, 10) *
      ((1 + i) ** (parseInt(timeperiod, 10) * 12) - 1) *
      ((1 + i) / i),
  )
}
export function sipReturns(
  frequency,
  totalYears,
  amountPerFrequency,
  expectedReturns,
) {
  let perFrequencyReturn = 0
  let iterations = 0
  let sipValue = 0
  if (frequency === 'daily') {
    perFrequencyReturn = expectedReturns / 365
    iterations = 365 * totalYears
  } else if (frequency === 'weekly') {
    perFrequencyReturn = expectedReturns / 52
    iterations = 52 * totalYears
  } else if (frequency === 'monthly') {
    // perFrequencyReturn = expectedReturns / 12
    perFrequencyReturn =
      ((1 + (expectedReturns as number) / 100) ** (1 / 12) - 1) * 100
    iterations = Math.round(12 * totalYears)
  } else if (frequency === 'quarterly') {
    perFrequencyReturn = expectedReturns / 4
    iterations = 4 * totalYears
  }

  for (let i = 0; i < iterations; i++) {
    sipValue =
      sipValue * (1 + perFrequencyReturn / 100) +
      amountPerFrequency * (1 + perFrequencyReturn / 100)
  }
  return {
    investedAmount: amountPerFrequency * iterations,
    sipValue,
  }
}

export const convertYearsToMonth = (years: number) => Math.round(years * 12)

export function getTimePeriodOfSIPCalc(year: number, barIndex: number) {
  const yearDivideBy5 = Math.round(year / 5)
  if (year < 5) {
    if (year - 4 + barIndex <= 0) {
      return ((Math.floor(12 / (6 - year)) * (barIndex + 1)) / 12).toFixed(4)
    } else {
      return year - 4 + barIndex
    }
  } else if (barIndex < 4) {
    return yearDivideBy5 * (barIndex + 1)
  }
  return year
}

export function getTimePeriodOfCalc(year: number, barIndex: number) {
  const yearDivideBy5 = Math.round(year / 5)
  if (year < 5) {
    return Math.max(0, year - 4 + barIndex)
  } else if (barIndex < 4) {
    return yearDivideBy5 * (barIndex + 1)
  }
  return year
}

export function getSIPGainAmount(sipValue4, investedAmount4) {
  return Math.round((sipValue4 - investedAmount4) * 100) / 100
}

export function getSIPFutureValuePercentage(sipValue4, investedAmount4) {
  if (investedAmount4 === 0) {
    return 0
  }
  const amount =
    (getSIPGainAmount(sipValue4, investedAmount4) * 100) / investedAmount4
  return Math.round(amount * 10) / 10
}

export function npsReturn(rate, monthlyAmount, presentAge) {
  const timePeriod = 60 - presentAge
  const totalInvestment = timePeriod * monthlyAmount * 12
  const toalCorpus = sipReturns(
    'monthly',
    timePeriod,
    monthlyAmount,
    rate,
  ).sipValue
  const capitalgain = toalCorpus - totalInvestment
  const lumpSumWithdrawn = toalCorpus * 0.6
  const annuity = toalCorpus * 0.4

  return {
    totalInvestment,
    toalCorpus,
    capitalgain,
    lumpSumWithdrawn,
    annuity,
  }
}

export function percentNPSReturn(type) {
  if (type === 'Aggressive') {
    return 11
  } else if (type === 'Moderate') {
    return 10
  } else {
    return 9
  }
}

export function lumpsumFormulaEstReturns(
  amount: string,
  err: string,
  timeperiod: string,
) {
  const r = parseFloat(err) / 100
  return Math.round(
    parseInt(amount, 10) * (1 + r) ** parseInt(timeperiod, 10) -
      parseInt(amount, 10),
  ).toLocaleString('en-IN')
}

export function lumpsumFormulaEstReturnsInNumber(
  amount: string,
  err: string,
  timeperiod: string,
) {
  const r = parseFloat(err) / 100
  return Math.round(
    parseInt(amount, 10) * (1 + r) ** parseInt(timeperiod, 10) -
      parseInt(amount, 10),
  )
}

export function lumpsumFormulaTotalValue(
  amount: string,
  err: string,
  timeperiod: string,
) {
  const r = parseFloat(err) / 100
  return Math.round(
    parseInt(amount, 10) * (1 + r) ** parseInt(timeperiod, 10),
  ).toLocaleString('en-IN')
}

export function swpWithdrawal(wpm: string, timeperiod: string) {
  return Math.round(
    parseInt(wpm, 10) * parseInt(timeperiod, 10) * 12,
  ).toLocaleString('en-IN')
}

export function swpTotalValue(
  amount: string,
  wpm: string,
  err: string,
  timeperiod: string,
) {
  const totalInvestmentValue = parseInt(amount, 10)
  const withdrawalAmountValue = parseInt(wpm, 10)
  const expectedReturnsValue = parseInt(err, 10)
  const tenureValue = parseInt(timeperiod, 10)
  return Math.round(
    totalInvestmentValue * (1 + expectedReturnsValue / 100) ** tenureValue -
      (withdrawalAmountValue *
        ((1 + ((1 + expectedReturnsValue / 100) ** (1 / 12) - 1)) **
          (tenureValue * 12) -
          1)) /
        ((1 + expectedReturnsValue / 100) ** (1 / 12) - 1),
  ).toLocaleString('en-IN')
}

export function mfTotalValue(amount: string, err: string, timeperiod: string) {
  const r = parseFloat(err) / 100
  return Math.round(parseInt(amount, 10) * (1 + r) ** parseInt(timeperiod, 10))
}

export function ppfInvestedAmount(
  yearlyInvestment: string,
  timeperiod: string,
) {
  return Math.round(parseInt(yearlyInvestment, 10) * parseInt(timeperiod, 10))
}

export function ppfMaturityValue(
  yearlyInvestment: string,
  timeperiod: string,
  interest: number,
) {
  function futureValue(
    rate: number,
    nper: number,
    pmt: number,
    pv: number,
    type: number,
  ) {
    const pow = (1 + rate) ** nper
    let fv
    if (rate) {
      fv = (pmt * (1 + rate * type) * (pow - 1)) / rate - pv * pow
    } else {
      fv = pv + pmt * nper
    }
    return Math.round(fv)
  }
  return futureValue(
    interest / 100,
    parseInt(timeperiod, 10),
    parseInt(yearlyInvestment, 10),
    0,
    1,
  )
}

export function epfTotalValue(
  monthlySalary: string,
  age: string,
  contri: string,
  annualIncrease: string,
  interest: number,
) {
  return true
}

export function compoundInterest(p: number, r: number, t: number) {
  return p * (1 + r / 100) ** t
}

export function fdFormulaEstReturns(
  amount: string,
  interest: string,
  timeperiod: string,
) {
  const p = parseFloat(amount) || 0
  const r = parseFloat(interest) || 0
  const t = parseFloat(timeperiod) || 0
  const CI = compoundInterest(p, r, t)
  return Math.round(CI - p).toLocaleString('en-IN')
}

export function fdFormulaTotalValue(
  amount: string,
  interest: string,
  timeperiod: string,
) {
  const p = parseFloat(amount) || 0
  const r = parseFloat(interest) || 0
  const t = parseFloat(timeperiod) || 0
  const CI = compoundInterest(p, r, t)
  return Math.round(CI).toLocaleString('en-IN')
}

export function rdInvestedAmount(
  monthlyInvestment: string,
  interest: string,
  timeperiod: string,
) {
  return Math.round(
    parseInt(monthlyInvestment, 10) * parseInt(timeperiod, 10) * 12,
  )
}

export function rdTotalValue(
  monthlyInvestment: string,
  interest: string,
  timeperiod: string,
) {
  const r = parseFloat(interest) / 400
  const quarters = parseInt(timeperiod, 10) * 4
  return Math.round(
    (parseInt(monthlyInvestment, 10) * ((1 + r) ** quarters - 1)) /
      (1 - (1 + r) ** (-1 / 3)),
  )
}

export function npsTotalInvestment(
  monthlyInvestment: string,
  err: string,
  age: string,
) {
  return true
}

export function npsInterestEarned(
  monthlyInvestment: string,
  err: string,
  age: string,
) {
  return true
}

export function npsMaturityAmt(
  monthlyInvestment: string,
  err: string,
  age: string,
) {
  return true
}

export function npsMinAnnuityInvestment(
  monthlyInvestment: string,
  err: string,
  age: string,
) {
  return true
}

export function emiMonthlyEMI(
  loanamt: string,
  interest: string,
  tenure: string,
) {
  const monthlyInterest = parseFloat(interest) / 12 / 100
  const tenureInMonths = parseInt(tenure, 10)
  return Math.round(
    (parseInt(loanamt, 10) *
      monthlyInterest *
      (monthlyInterest + 1) ** tenureInMonths) /
      ((monthlyInterest + 1) ** tenureInMonths - 1),
  )
}

export function emiTotalInterest(loanamt: string, totalAmt: number) {
  return totalAmt - parseInt(loanamt, 10)
}

export function emiTotalAmt(monthlyEmi: number, tenure: string) {
  return parseInt(tenure, 10) * monthlyEmi
}

export function simpleInterestTotalInterest(
  principalAmount: string,
  interest: string,
  timeperiod: string,
) {
  return Math.round(
    (parseFloat(principalAmount) *
      parseFloat(interest) *
      parseFloat(timeperiod)) /
      100,
  )
}

export function compoundInterestTotalInterest(
  principalAmount: string,
  interest: string,
  timeperiod: string,
  frequency: string,
) {
  if (frequency === 'yearly') {
    return Math.round(
      parseInt(principalAmount, 10) *
        (1 + parseFloat(interest) / 100) ** parseInt(timeperiod, 10) -
        parseInt(principalAmount, 10),
    )
  } else if (frequency === 'halfyearly') {
    return Math.round(
      parseInt(principalAmount, 10) *
        (1 + parseFloat(interest) / 200) ** (parseInt(timeperiod, 10) * 2) -
        parseInt(principalAmount, 10),
    )
  } else {
    return Math.round(
      parseInt(principalAmount, 10) *
        (1 + parseFloat(interest) / 400) ** (parseInt(timeperiod, 10) * 4) -
        parseInt(principalAmount, 10),
    )
  }
}

export function nscTotalInterest(
  principalAmount: string,
  interest: string,
  timeperiod: number,
  frequency: string,
) {
  if (frequency === 'yearly') {
    return Math.round(
      parseInt(principalAmount, 10) *
        (1 + parseFloat(interest) / 100) ** timeperiod -
        parseInt(principalAmount, 10),
    )
  } else {
    return Math.round(
      parseInt(principalAmount, 10) *
        (1 + parseFloat(interest) / 200) ** (timeperiod * 2) -
        parseInt(principalAmount, 10),
    )
  }
}

export function gratuity(monthlySalary: string, yearsOfService: string) {
  return Math.round(
    (parseInt(monthlySalary, 10) * parseInt(yearsOfService, 10) * 15) / 26,
  )
}

export function apyMonthlyInvestment(
  joiningAge: string,
  monthlyPension: string,
) {
  const joinAge = Math.max(18, Math.min(39, parseInt(joiningAge, 10) || 18))
  const monthPension = Math.max(
    1000,
    Math.min(5000, parseInt(monthlyPension, 10) || 1000),
  )

  const row = joinAge - 18
  const col = Math.round(monthPension / 1000) - 1
  return atalPensionYojanaTable[row][col]
}

export function apyInvestmentDuration(joiningAge: string) {
  const joinAge = Math.max(18, Math.min(39, parseInt(joiningAge, 10) || 18))
  return 60 - joinAge
}

export function apyTotalAmt(joiningAge: string, monthlyPension: string) {
  return (
    apyMonthlyInvestment(joiningAge, monthlyPension) *
    apyInvestmentDuration(joiningAge) *
    12
  )
}

export function pomisMonthlyIncome(
  investmentAmount: string,
  interestRate: string,
) {
  return Math.round(
    ((parseInt(investmentAmount, 10) || 0) * (parseFloat(interestRate) || 0)) /
      (100 * 12),
  )
}

export function priceAfterDiscount(price: string, discount: string) {
  return Math.round(
    (parseFloat(price) || 0) - savedPriceAfterDiscount(price, discount),
  )
}

export function savedPriceAfterDiscount(price: string, discount: string) {
  return Math.round(
    ((parseFloat(price) || 0) * (parseFloat(discount) || 0)) / 100,
  )
}

export function cagr(
  initialInvestment: string,
  finalInvestment: string,
  timeperiod: string,
) {
  return (
    ((parseInt(finalInvestment, 10) / parseInt(initialInvestment, 10)) **
      (1 / parseInt(timeperiod, 10)) -
      1) *
    100
  ).toFixed(2)
}

export function gstTotal(amount: string, tax: string, gst: string) {
  if (gst === 'gstExclusive') {
    return Math.round(parseInt(amount, 10) * (parseInt(tax, 10) / 100))
  } else {
    return Math.round(parseInt(amount, 10) / (1 + parseInt(tax, 10) / 100))
  }
}

export function stepUpSIPTotalInvestment(
  monthlyInvestment: string,
  timeperiod: string,
  err: string,
  annualStepUp: string,
) {
  const P = parseFloat(monthlyInvestment) || 0
  const n = parseInt(timeperiod, 10) || 0
  const r = (parseFloat(annualStepUp) || 0) / 100

  const totalInvestment = P * 12 * (((1 + r) ** n - 1) / r)

  return Math.round(totalInvestment || 0)
}

export function stepUpSIPEstReturns(
  monthlyInvestment: string,
  timeperiod: string,
  err: string,
  annualStepUp: string,
) {
  return (
    stepUpSIPTotalValue(monthlyInvestment, timeperiod, err, annualStepUp) -
    stepUpSIPTotalInvestment(monthlyInvestment, timeperiod, err, annualStepUp)
  )
}

export function stepUpSIPTotalValue(
  monthlyInvestment: string,
  timeperiod: string,
  err: string,
  annualStepUp: string,
) {
  let P = parseFloat(monthlyInvestment) || 0
  const n = parseInt(timeperiod, 10) || 0
  const r = (parseInt(err, 10) || 0) / (12 * 100)
  const ar = (parseFloat(annualStepUp) || 0) / 100

  let TotalSIP = 0
  for (let year = 1; year <= n; year++) {
    for (let month = 1; month <= 12; month++) {
      const remMonths = 12 * n - month - (year - 1) * 12 + 1
      TotalSIP += P * (1 + r) ** remMonths
    }
    P += P * ar
  }
  return Math.round(TotalSIP)
}

export function stepUpSIPValueArray(
  monthlyInvestment: string,
  timeperiod: string,
  err: string,
  annualStepUp: string,
  timeArray: number[],
) {
  let P = parseFloat(monthlyInvestment) || 0
  const n = parseInt(timeperiod, 10) || 0
  const r = (parseInt(err, 10) || 0) / (12 * 100)
  const ar = (parseFloat(annualStepUp) || 0) / 100

  const ans: number[] = new Array(5).fill(0)
  let index = 0,
    TotalSIP = 0
  while (index < 5 && timeArray[index] == 0) index++
  for (let year = 1; year <= n; year++) {
    for (let month = 1; month <= 12; month++) {
      const remMonths = 12 * n - month - (year - 1) * 12 + 1
      TotalSIP += P * (1 + r) ** remMonths
    }
    while (index < 5 && year == timeArray[index]) ans[index++] = TotalSIP
    P += P * ar
  }
  return ans
}

export function exemptedHRA(
  basicSalary: number,
  dearAllow: number,
  hraInput: number,
  rent: number,
  metro: string,
) {
  if (metro === 'Yes') {
    return 12536
  } else {
    return 0
  }
}

export function taxableHRA(
  basicSalary: number,
  dearAllow: number,
  hraInput: number,
  rent: number,
  metro: string,
) {
  if (metro === 'Yes') {
    return 0
  } else {
    return 12536
  }
}

export function stpPerMonth(investment: string, timeperiod: string) {
  return Math.round(parseInt(investment, 10) / parseInt(timeperiod, 10))
}

/* <-------------------- Return Calculator Formulas - Starting--------------------> */

interface ReturnsAmount {
  value: number
  actualValue: number
  color: string
  percent: string
}

export const getStockReturns = (
  oldStockValueInDollars: number,
  currentStockValueInDollars: number,
  investment: number,
  oldDollarValue: number,
): ReturnsAmount => {
  const investedDollarsAmount = investment / oldDollarValue
  const currentValueInDollars =
    currentStockValueInDollars *
    (investedDollarsAmount / oldStockValueInDollars)
  const returnAmt = currentValueInDollars - investedDollarsAmount
  const finalStockReturns = returnAmt * oldDollarValue
  return {
    value: Math.abs(finalStockReturns),
    color: returnAmt < 0 ? 'text-brand-red-cinnabar' : 'text-brand-green-dark',
    percent: `(${returnAmt > 0 ? '+' : ''}${formatNumberToString(
      (returnAmt / investedDollarsAmount) * 100,
      true,
      2,
    )}%)`,
    actualValue: finalStockReturns,
  }
}

export const getDollarReturns = (
  investment: number,
  oldDollarValue: number,
  currentDollarValue: number,
): ReturnsAmount => {
  const dollarsOld = investment / oldDollarValue
  const newRupeeTotalValue = dollarsOld * currentDollarValue
  const returnAmt = newRupeeTotalValue - investment
  return {
    value: Math.abs(returnAmt),
    color: returnAmt < 0 ? 'text-brand-red-cinnabar' : 'text-brand-green-dark',
    percent: `(${returnAmt > 0 ? '+' : ''}${formatNumberToString(
      (returnAmt / investment) * 100,
      true,
      2,
    )}%)`,
    actualValue: returnAmt,
  }
}

export const getFinalReturns = (
  totalCurrentValue: number,
  investment: number,
): ReturnsAmount => {
  const totalReturn = totalCurrentValue - investment
  return {
    value: Math.abs(totalReturn),
    color:
      totalReturn < 0 ? 'text-brand-red-cinnabar' : 'text-brand-green-dark',
    percent: `(${totalReturn > 0 ? '+' : ''}${formatNumberToString(
      (totalReturn / investment) * 100,
      true,
      2,
    )}%)`,
    actualValue: totalReturn,
  }
}

/* <-------------------- Return Calculator Formulas - Ending--------------------> */

/* <-------------------- Brokerage Calculator Formulas - Starting--------------------> */
export const calculateBrokerage = (orderValue: number) => {
  if (orderValue <= 80) {
    return (2.5 * orderValue) / 100
  } else if (orderValue > 80 && orderValue <= 4000) {
    return 2
  } else if (orderValue > 4000 && orderValue <= 20000) {
    return (0.1 / 100) * orderValue
  } else if (orderValue > 20000) {
    return 20
  }
  return 0
}
/* <-------------------- Brokerage Calculator Formulas - Ending--------------------> */

/* <-------------------- MTF Calculator Formulas - Starting--------------------> */

/**
 * Calculates the MTF (Margin Trading Facility) values based on user inputs
 *
 * @param formValues - User input values from the form
 * @param isDisabled - Whether the calculation is disabled
 * @returns Object containing all calculated values for MTF
 */
export const calculateMTF = (formValues: FieldValues, isDisabled: boolean) => {
  // Return minimal object if calculation is disabled
  if (isDisabled)
    return {
      boost: 0,
      totalInvestment: 0,
      totalReturns: 0,
      netProfitLoss: 0,
    }

  // Step 1: Calculate basic investment values
  const totalInvestment = formValues.buyPrice * formValues.quantity
  const totalReturns = formValues.sellPrice * formValues.quantity

  // Step 2: Calculate funding breakdown
  const boost = formValues.boost
  const yourFunds = totalInvestment / boost
  const brokerFunds = totalInvestment - yourFunds

  // Step 3: Calculate fixed charges
  const pledge = 20 // Only Buy
  const unpledge = 20 // Only Sell
  const dpCharge = 18.5 // Only Sell

  // Step 4: Calculate brokerage (capped between 2 and 20) - For buy and sell
  const brokerage =
    Math.max(2, Math.min(20, totalInvestment * 0.001)) +
    Math.max(2, Math.min(20, totalReturns * 0.001))

  // Step 5: Calculate turnover-based charges
  const turnover = totalInvestment + totalReturns
  const exchangeTransactionCharge = 0.0000297 * turnover
  const stt = 0.001 * turnover
  const sebiCharges = 0.000001 * turnover
  const ipft = 0.000001 * turnover
  const stampDuty = 0.00015 * turnover

  // Step 6: Calculate GST (18% on applicable charges)
  const gst =
    (brokerage +
      dpCharge +
      exchangeTransactionCharge +
      sebiCharges +
      pledge +
      unpledge) *
    0.18

  // Step 7: Calculate total transaction charges
  const totalTransactionCharges =
    pledge +
    unpledge +
    stt +
    exchangeTransactionCharge +
    dpCharge +
    gst +
    sebiCharges +
    brokerage +
    stampDuty +
    ipft

  // Step 8: Calculate interest amount (only if broker funds >= 10000)
  const interestAmount =
    brokerFunds < 10000
      ? 0
      : 0.0004 * (brokerFunds - 10000) * Number(formValues.holdingPeriod)

  const netProfitLoss =
    totalReturns - totalInvestment - totalTransactionCharges - interestAmount

  const profitWithoutMtf =
    totalReturns - totalInvestment - totalTransactionCharges
  const profitWithMtf = profitWithoutMtf - interestAmount

  const profitWithoutMtfPercentage =
    totalInvestment > 0 ? (profitWithoutMtf / totalInvestment) * 100 : 0
  const profitWithMtfPercentage =
    yourFunds > 0 ? (profitWithMtf / yourFunds) * 100 : 0

  // Return all calculated values
  return {
    // Investment values
    totalInvestment,
    totalReturns,
    turnover,
    netProfitLoss,

    // Funding breakdown
    yourFunds,
    brokerFunds,
    boost,

    // Fixed charges
    pledge,
    unpledge,
    dpCharge,

    // Variable charges
    exchangeTransactionCharge,
    stt,
    sebiCharges,
    ipft,
    stampDuty,
    brokerage,
    gst,

    // Total charges
    totalTransactionCharges,
    interestAmount,

    //profit percentage
    profitWithoutMtfPercentage:
      Math.floor(profitWithoutMtfPercentage * 100) / 100,
    profitWithMtfPercentage: Math.floor(profitWithMtfPercentage * 100) / 100,
  }
}

/**
 * Generates a breakdown of MTF calculation results for display in the UI
 *
 * @param results - Results from calculateMTF function
 * @returns Array of row objects for display in the results table
 */
export const getMTFBreakdown = ({
  results,
}: {
  results: ReturnType<typeof calculateMTF>
}) => {
  return [
    // Trade values
    {
      title: 'Sell Value',
      value: formatNumberToINRCommaSeparatedString(results.totalReturns, 2),
    },
    {
      title: `Buy Value (${results.boost}x)`,
      value: formatNumberToINRCommaSeparatedString(results.totalInvestment, 2),
      subRows: [
        {
          subTitle: 'Your Funds (1x)',
          subValue: formatNumberToINRCommaSeparatedString(results.yourFunds, 2),
        },
        {
          subTitle: `Funded by INDmoney (${
            results.boost ? (results.boost - 1).toFixed(2) : 1
          }x)`,
          subValue: formatNumberToINRCommaSeparatedString(
            results.brokerFunds,
            2,
          ),
        },
      ],
    },

    // Transaction charges with breakdown
    {
      title: 'Transaction Charges',
      value: formatNumberToINRCommaSeparatedString(
        results.totalTransactionCharges,
        2,
      ),
      subRows: [
        {
          subTitle: 'STT Total',
          subValue: formatNumberToINRCommaSeparatedString(results.stt, 2),
        },
        {
          subTitle: 'Transaction Charge',
          subValue: formatNumberToINRCommaSeparatedString(
            results.exchangeTransactionCharge,
            2,
          ),
        },
        {
          subTitle: 'DP Charge',
          subValue: formatNumberToINRCommaSeparatedString(results.dpCharge, 2),
        },
        {
          subTitle: 'GST',
          subValue: formatNumberToINRCommaSeparatedString(results.gst, 2),
        },
        {
          subTitle: 'SEBI Charges',
          subValue: formatNumberToINRCommaSeparatedString(
            results.sebiCharges,
            2,
          ),
        },
        {
          subTitle: 'IPFT',
          subValue: formatNumberToINRCommaSeparatedString(results.ipft, 2),
        },
        {
          subTitle: 'Brokerage',
          subValue: formatNumberToINRCommaSeparatedString(results.brokerage, 2),
        },
        {
          subTitle: 'Stamp Duty',
          subValue: formatNumberToINRCommaSeparatedString(results.stampDuty, 2),
        },
        {
          subTitle: 'Pledge Charges',
          subValue: formatNumberToINRCommaSeparatedString(results.pledge, 2),
        },
        {
          subTitle: 'Unpledge Charges',
          subValue: formatNumberToINRCommaSeparatedString(results.unpledge, 2),
        },
      ],
    },

    // Interest amount
    {
      title: 'Interest Amount',
      titleInfo: '0% interest upto ₹10,000 on INDmoney funded amount',
      value: formatNumberToINRCommaSeparatedString(results.interestAmount, 2),
    },
  ]
}
/* <-------------------- Brokerage Calculator Formulas - Ending--------------------> */
